/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import React, { type Ref } from 'react';
import { MENU_ID_CUSTOMERS } from '@jira/navigation-apps__sidebar-nav4-context/src/common/constants.tsx';
import { Nav4MenuLinkItem } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/ui/nav4-menu-link-item/index.tsx';
import { useConfigurableMessageAndIconMap } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/controllers/use-configurable-message-and-icon-map/index.tsx';
import { HideL1MenuItemSection } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/ui/hide-l1-menu-item-action/index.tsx';
import { MoreNavMenuButton } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/ui/more-nav-menu-button/main.tsx';
import { customerServiceCustomersRoute } from '@jira/router-routes__customer-services-customers-routes/src/customerServiceCustomersRoute.tsx';
import { getMenuItemAnalytics } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/utils/get-analytics-attributes/index.tsx';
import { MENU_ID_ANALYTIC_EVENT_IDS } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/side-nav.tsx';
// eslint-disable-next-line jira/import/file-extension-required
import { componentWithFG } from '@jira/platform__utils-feature-gates-gate-component';
import type { Nav4DragAndDropMenuItemProps } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/types.tsx';
import { csmCustomersRoute } from '@jira/router-routes__customer-services-customers-routes/src/csmCustomersRoute.tsx';
import MenuGroup from '@atlaskit/menu/menu-group';
import { fg } from '@atlassian/jira-feature-gating';
import { generatePath } from '@atlassian/react-resource-router';

interface Props extends Nav4DragAndDropMenuItemProps {}

export const CustomersMenuLinkItem: React.FC<Props> = componentWithFG<Props, {}>(
	'navx-global-side-nav',
	CustomersMenuLinkItemNEW,
	CustomersMenuLinkItemOLD,
);

function CustomersMenuLinkItemNEW(props: Props): React.JSX.Element {
	const { draggableRef, dropIndicator, hasDragIndicator, isDragging, visualContentRef } = props;
	const { formattedMessage, icon } = useConfigurableMessageAndIconMap(MENU_ID_CUSTOMERS);
	// oxlint-disable-next-line typescript/consistent-type-assertions
	const ref = draggableRef as Ref<HTMLAnchorElement> | undefined;

	const analytics = getMenuItemAnalytics({
		actionSubjectId: MENU_ID_ANALYTIC_EVENT_IDS[MENU_ID_CUSTOMERS],
		itemId: 'customers',
		level: 1,
	});

	return (
		<Nav4MenuLinkItem
			analytics={analytics}
			dropIndicator={dropIndicator}
			elemBefore={icon}
			hasDragIndicator={hasDragIndicator}
			href={generatePath(
				fg('csm_appification_standalone_navigation')
					? csmCustomersRoute.path
					: customerServiceCustomersRoute.path,
			)}
			isDragging={isDragging}
			menuId={MENU_ID_CUSTOMERS}
			ref={ref}
			// eslint-disable-next-line jira/integration/test-id-by-folder-structure
			testId="navigation-apps-sidebar-nav4-sidebars-content-customers.ui.sidenav-customers"
			visualContentRef={visualContentRef}
		>
			{formattedMessage}
		</Nav4MenuLinkItem>
	);
}

function CustomersMenuLinkItemOLD(): React.JSX.Element {
	const { formattedMessage, icon } = useConfigurableMessageAndIconMap(MENU_ID_CUSTOMERS);

	const analytics = getMenuItemAnalytics({
		actionSubjectId: MENU_ID_ANALYTIC_EVENT_IDS[MENU_ID_CUSTOMERS],
		itemId: 'customers',
		level: 1,
	});

	return (
		<Nav4MenuLinkItem
			// eslint-disable-next-line jira/integration/test-id-by-folder-structure
			testId="navigation-apps-sidebar-nav4-sidebars-content-customers.ui.sidenav-customers"
			href={generatePath(
				fg('csm_appification_standalone_navigation')
					? csmCustomersRoute.path
					: customerServiceCustomersRoute.path,
			)}
			menuId={MENU_ID_CUSTOMERS}
			elemBefore={icon}
			actionsOnHover={<MoreNavMenuButton MenuItems={MenuItems} name={formattedMessage} />}
			analytics={analytics}
		>
			{formattedMessage}
		</Nav4MenuLinkItem>
	);
}

const MenuItems = () => (
	<MenuGroup>
		<HideL1MenuItemSection menuId={MENU_ID_CUSTOMERS} hasSeparator={false} />
	</MenuGroup>
);
